import React, { useEffect, useRef, useState } from "react";
import filter from "../../asset/images/calendar-lock-01.svg";
import { Modal } from "react-bootstrap";
import { Welcome_Letter } from "../../Configuration/API_URL";
import { alphaNumericUppercase, alphaNumericUppercasePaste, decryptData, encryptData, formattedDateSlash, getInitials, noDataFound, toSentenceCase, toTitleCase } from "../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axiosInstance from "../../CommonMethhods/axiosInstance";
import { useDebounce } from "../../Components/useDebounce";
import moment from "moment";
import Header from "../../Components/Header";
import Loader from "../../Components/Common/Loader";
import SmallLoader from "../../Components/Common/smallLoader";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import downloadIcon from "../../asset/images/download-brokrage.svg";
import DateRangePicker from "../../CommonMethhods/DateRangePicker";
import sideArrow from "../../asset/images/side-arrow.svg";
import grayArrow from "../../asset/images/gray-arrow.svg";

function WelcomeLetterDashboard(props) {
    const [serviceRequests, setServiceRequests] = useState([]);
    const [search, setSearch] = useState("");
    const [filterModal, setFilterModal] = useState(false);
    const [cardData, setCardData] = useState("");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [statusFilter, setStatusFilter] = useState("all");
    const [count, setCount] = useState();
    const [selectedSR, setSelectedSR] = useState(null);
    const [excelLoader, setExcelLoader] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [loader, setLoader] = useState(false);
    const [cardLoader, setCardLoader] = useState(false);
    const reviewSectionRef = useRef(null);
    const [csvLoader, setCsvLoader] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [rejectionModal, setRejectionModal] = useState(false);
    const [clDetails, setClDetails] = useState({});
    const [clDetailsLoader, setClDetailLoader] = useState(false);
    const [resetKey, setResetKey] = useState(0);
    const [dateErr, setDateErr] = useState("");

    const debouncedValue = useDebounce(search, 1000);

    const storeToken = localStorage.getItem("ssoToken");
     
     if (storeToken === null) {
        window.location.replace("/");
    }

    useEffect(() => {
        setPage(1);
    }, [debouncedValue]);

    const getCardCount = async () => {
        setCardLoader(true);
        try {
            const getDetails = await axiosInstance.get(
                Welcome_Letter.cardCounts,

            );
            const res = JSON.parse(decryptData(getDetails?.data));
            if (res?.status === 0) {
                setCardData(res?.data)

            } else {
                toast.error(res?.message);
            }
        } catch (error) {
            console.log(error);

        } finally {
            setCardLoader(false);
        }
    };

    const showFilterModal = () => {
        setFilterModal(true);
    }

    useEffect(() => {
        getCardCount();
    }, []);

    const getHistoryData = async (searchKey, startDate, endDate, status = statusFilter) => {
        setLoader(true);

        const payload = {
            status: status === "all" ? "" : status,
            search: searchKey,
            offset: page,
            limit: limit,
            start_date: startDate ? moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD") : "",
            end_date: endDate ? moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD") : "",
        };

        const encryptedPayload = encryptData(JSON.stringify(payload));
        console.log(encryptedPayload, payload, "encryptedPayload");


        try {
            const getDetails = await axiosInstance.post(
                Welcome_Letter.welcomeHistory,
                encryptedPayload,
                {
                    transformRequest: [(data) => data],
                }
            );
            const decryptedRes = decryptData(getDetails?.data);
            let res = JSON.parse(decryptedRes);
            console.log(res, "table");

            if (res?.status === 0) {
                setServiceRequests(res?.data?.requestHistories);
                setCount(res?.data?.totalCounts);
                setDateErr("");
            } else {
                setServiceRequests([]);
                toast.error(res?.message);
            }
        } catch (error) {
            setServiceRequests([]);
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getHistoryData(debouncedValue, fromDate, toDate);
    }, [page, limit, statusFilter, debouncedValue]);

    const handleNotifyBtn = () => {
        if (selectedRows.length === 0) {
            toast.error("Please select at least one client");
            return;
        }

        sendNotifications();
    };

    const sendNotifications = async () => {
        setExcelLoader(true)


        const selectedClients = serviceRequests
            .filter((sr) => selectedRows.includes(sr.clientCode))
            .map((sr) => ({
                clientCode: sr?.clientCode || "",
                clientName: sr?.clientName || "",
                dematAcNo: sr?.dematAcNo || "",
                email: sr?.email || "",
                accountOpeningDate: sr?.accountOpeningDate,
                t2Deadline: sr?.t2Deadline,
                commDate: sr?.commDate,
                deliveryStatus: sr?.deliveryStatus,
                remarks: sr?.remarks
            }));
        console.log(selectedClients, "selectedClients");


        const encryptedPayload = encryptData(JSON.stringify(selectedClients));
        try {

            const getDetails = await axiosInstance.post(
                Welcome_Letter.sendNotification,
                encryptedPayload,
                {
                    transformRequest: [(data) => data],
                }

            );
            const decryptedRes = decryptData(getDetails?.data);
            let res = JSON.parse(decryptedRes);

            console.log(res, "viewTable00");
            if (res?.status === 0) {
                toast.success(res?.data)

            } else {
                toast.error(res?.message);
            }
        } catch (error) {
            console.log(error);

        } finally {
            setExcelLoader(null)
        }
    };

    const downloadTableData = async (sr) => {
        setCsvLoader(true);

        try {

            const getDetails = await axiosInstance.get(
                Welcome_Letter.csvDownload,
            );
            const res = JSON.parse(decryptData(getDetails?.data));
            console.log(res?.data, "download");
            if (res?.status === 0) {
                window.open(res?.data, "_self", "noopener,noreferrer");
            } else {
                toast.error(res?.message);
            }
        } catch (error) {
            console.log(error);

        } finally {
            setCsvLoader(false)
        }
    };

    const handleResetFilter = () => {
        setFromDate("");
        setToDate("");
        getHistoryData(search, "", "");
        setResetKey((prev) => prev + 1);
    };

    const handleFilterKeyDown = (e) => {
        if (e.key === "Enter" && isBothDatesSelected) {
            e.preventDefault();
            handleApplyFilter();
        }
    };

    const getClientDetails = async (id) => {
        setClDetailLoader(true);

        const payload = {
            id: id
        };

        const encryptedPayload = encryptData(JSON.stringify(payload));
        console.log(encryptedPayload, payload, "encryptedPayload");

        try {
            const getDetails = await axiosInstance.post(
                Welcome_Letter.clientDetails,
                encryptedPayload,
                {
                    transformRequest: [(data) => data],
                }
            );
            const decryptedRes = decryptData(getDetails?.data);
            let res = JSON.parse(decryptedRes);
            console.log(res, "tableClient");

            if (res?.status === 0) {
                if (res?.data?.length > 0) {
                    const item = res.data[0];
                    const modalData = {
                        accountOpeningDate: item?.accountOpeningDate,
                        clientName: item?.clientName,
                        clientCode: item?.clientCode,
                        deliveryStatus: item?.deliveryStatus || "-",
                        dematAccountNo: item?.dematAccountNo,
                        email: item?.email,
                        matchedCommDate: item?.matchedCommDate,
                        matchedSubjectLine: item?.matchedSubjectLine,
                        t2Deadline: item?.t2Deadline,
                    };
                    setRejectionModal(true);
                    setClDetails(modalData);
                } else {
                    setClDetails({})
                }
            } else {
                setClDetails({});
                toast.error(res?.message);
            }
        } catch (error) {
            setClDetails({});
            console.log(error);
        } finally {
            setClDetailLoader(false);
        }
    };

    const handleStatusCardClick = (status) => {
        setPage(1);
        setStatusFilter(status);
    };

    const handleClDetailsModal = (id) => {
        getClientDetails(id)
    }

    useEffect(() => {
        if (selectedSR) {
            reviewSectionRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [selectedSR]);

    const handleApplyFilter = () => {
        setPage(1);

        const from = moment(fromDate, "DD-MM-YYYY", true);
        const to = moment(toDate, "DD-MM-YYYY", true);
        const today = moment().startOf("day");

        if (fromDate === "" && toDate === "") {
            setDateErr("Please enter From date and To date");
            // toast.error("Please enter valid dates");
            return;
        }

        if (fromDate === "") {
            setDateErr("Please enter From date");
            return;
        }
        if (toDate === "") {
            setDateErr("Please enter To date");
            return;
        }

        if (!from.isValid() || !to.isValid()) {
            setDateErr("Please enter valid dates");
            // toast.error("Please enter valid dates");
            return;
        }

        if (from.isAfter(today)) {
             setDateErr("From Date cannot be a future date");
            // toast.error("From Date cannot be a future date");
            return;
        }

        if (to.isAfter(today)) {
            setDateErr("To Date cannot be a future date");
            // toast.error("To Date cannot be a future date");
            return;
        }

        if (to.isBefore(from)) {
            setDateErr("To Date cannot be earlier than From Date");
            // toast.error("To Date cannot be earlier than From Date");
            return;
        }

        // const diff = to.diff(from, "days");

        // if (diff > 31) {
        //     toast.error("Date range should not exceed 1 month");
        //     return;
        // }

        getHistoryData(search, fromDate, toDate);
        setFilterModal(false);
    };

    const isBothDatesSelected =
        fromDate &&
        toDate &&
        fromDate.split("-").length === 3 &&
        toDate.split("-").length === 3;

    const isAnyDateSelected = !!fromDate || !!toDate;

    console.log(selectedSR, "selectedSR");

    const handleCloseFilter = () => {
        setFromDate("");
        setToDate("");
        setDateErr("");
        setFilterModal(false);
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const bouncedRows = serviceRequests
                .filter((sr) => sr.deliveryStatus === "bounced")
                .map((sr) => sr.clientCode);

            setSelectedRows(bouncedRows);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (clientCode) => {
        setSelectedRows((prev) =>
            prev.includes(clientCode)
                ? prev.filter((item) => item !== clientCode)
                : [...prev, clientCode]
        );
    };

    const getStatusClass = (status = "") => {
        switch (status.toLowerCase()) {
            case "opened":
                return "status-pending";
            case "abuse":
                return "status-abuse";
            case "clicked":
                return "status-clicked";
            case "delivered":
                return "status-approved";
            case "dropped":
                return "status-partial";
            case "invalid":
                return "status-invalid";
            case "sent":
                return "status-sent";
            case "unsubscribed":
                return "status-rejected";
            case "bounced":
                return "status-draft";
            default:
                return "";
        }
    };

    const totalPages = Math.ceil(count / limit);
    const pagesPerGroup = 3;

    const currentGroup = Math.floor((page - 1) / pagesPerGroup);

    const startPage = currentGroup * pagesPerGroup + 1;
    const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);

    const visiblePages = Array.from(
        { length: endPage - startPage + 1 },
        (_, index) => startPage + index
    );


    return (
        <>
            <div className="off-market-main welcome-letter-main">
                <Header title={props.title} portal={""} />
                <SingleSignOnSideBar />
                <main id="wel-lett-main-content">
                    <div className="tab-content card-box off-market-tab welcome-letter-tab" id="mainTabContent">
                        <div className="new-upload">

                            <div className="welc-card-wrapper">
                                <div className="card-alignment">
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Total clients</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.total || "0"}</span>
                                                }
                                            </span>

                                        </div>

                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("abuse")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Abuse</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.abuse || "0"}</span>
                                                }
                                            </span>
                                            
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("bounced")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Bounced</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.bounced || "0"}</span>}
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("clicked")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Clicked</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.clicked || "0"}</span>
                                                }
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("delivered")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Delivered</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.delivered || "0"}</span>
                                                }
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("dropped")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Dropped</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.dropped || "0"}</span>
                                                }
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("invalid")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Invalid</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.invalid || "0"}</span>
                                                }
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("opened")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Opened</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.opened || "0"}</span>
                                                }
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("sent")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Sent</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.sent || "0"}</span>
                                                }
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>
                                    <div className="status-card-content"
                                        onClick={() => handleStatusCardClick("unsubscribed")}>
                                        <div className="wel-stat-info d-flex flex-column">
                                            <span className="status-title">Unsubscribed</span>
                                            <span className="wrap-card-text">
                                                {cardLoader ?
                                                    <SmallLoader /> :
                                                    <span className="welc-stat-value">{cardData?.unsubscribed || "0"}</span>}
                                            </span>
                                        </div>
                                        <img src={sideArrow} alt="side-arrow" />
                                    </div>

                                </div>
                            </div>

                            <div className="dashboard-table">

                                <div className="table-section-header">
                                    <p className="welcome-table-title">Requests History</p>

                                    <div className="header-filter">

                                        <div className="filter-options">
                                            <div className="dropdown-filter">
                                                <select
                                                    size="lg"
                                                    aria-label="Default select example"
                                                    value={statusFilter}
                                                    onChange={(e) => {
                                                        setPage(1);
                                                        setStatusFilter(e.target.value)
                                                    }}
                                                    style={{
                                                        backgroundImage: `url("${grayArrow}")`,
                                                        backgroundPosition: "right 12px center",
                                                        backgroundRepeat: "no-repeat",
                                                        backgroundSize: "12px",
                                                        appearance: "none",
                                                        paddingRight: "35px"
                                                    }}
                                                >
                                                    <option value="">All Statuses</option>
                                                    <option value="abouse">Abuse</option>
                                                    <option value="bounced">Bounced</option>
                                                    <option value="clicked">Clicked</option>
                                                    <option value="delivered">Delivered</option>
                                                    <option value="dropped">Dropped</option>
                                                    <option value="invalid">Invalid</option>
                                                    <option value="opened">Opened</option>
                                                    <option value="sent">Sent</option>
                                                    <option value="unsubscribed">Unsubscribed</option>

                                                </select>
                                            </div>
                                        </div>

                                        <div className="filter-wrapper" onClick={showFilterModal}>
                                            <img src={filter} alt="filter" />
                                        </div>
                                        <div className="search-boxinput">
                                            <i className="fa fa-search" />
                                            <input
                                                type="text"
                                                placeholder="Search by client code/name"
                                                value={search}
                                                maxLength={50}
                                                onChange={(e) =>
                                                    setSearch(alphaNumericUppercase(e.target.value, 50))
                                                }
                                                onPaste={alphaNumericUppercasePaste(50)}

                                            />
                                        </div>

                                        <div className="wrap-down-btn" onClick={handleNotifyBtn}>
                                            {excelLoader ?
                                                <SmallLoader />
                                                :
                                                <>
                                                    <button className="download-template"
                                                    >
                                                        Notify Surveillance & Risk</button>
                                                </>}
                                        </div>

                                        <div className="wrap-down-btn excel-welcome" onClick={downloadTableData}>
                                            {csvLoader ?
                                                <SmallLoader />
                                                :
                                                <>
                                                    <button className="download-template"
                                                    >
                                                        <img src={downloadIcon} alt="download" />
                                                        <span>Export CSV</span>
                                                    </button>
                                                </>
                                            }
                                        </div>

                                    </div>
                                </div>

                                <div className="dashboard-table-wrapper">
                                    {loader ?
                                        <div className="loader-alignment">
                                            <Loader />
                                        </div>
                                        :
                                        serviceRequests && serviceRequests?.length > 0 ?
                                            <>
                                                <table className="welcome-table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <input
                                                                    className="check-box"
                                                                    type="checkbox"
                                                                    checked={
                                                                        serviceRequests.length > 0 &&
                                                                        selectedRows.length === serviceRequests.filter(
                                                                            (sr) => sr.deliveryStatus === "bounced" || sr.deliveryStatus === "unsubscribed" || sr.deliveryStatus === "abuse"
                                                                        ).length
                                                                    }
                                                                    onChange={handleSelectAll}
                                                                    // onChange={() => handleRowSelect(sr?.clientCode)}
                                                                    disabled={
                                                                        serviceRequests.filter(
                                                                            (sr) => sr.deliveryStatus === "bounced" || sr.deliveryStatus === "unsubscribed" || sr.deliveryStatus === "abuse"
                                                                        ).length === 0
                                                                    }
                                                                />
                                                            </th>
                                                            <th>Client Code</th>
                                                            <th>Client Name</th>
                                                            <th>Demat A/C No.</th>
                                                            <th>Email</th>
                                                            <th>A/C Opening Date</th>
                                                            <th>T+2 Deadline</th>
                                                            <th>Comm. Date</th>
                                                            <th>Delivery Status</th>
                                                            <th>Remarks</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {serviceRequests.map((sr) => (
                                                            <tr
                                                                key={sr.clientCode}
                                                                className={selectedSR?.clientCode === sr.clientCode ? "ckr-active-row" : ""}
                                                            >
                                                                <td>
                                                                    <input
                                                                        className="check-box"
                                                                        type="checkbox"
                                                                        checked={selectedRows.includes(sr?.clientCode)}
                                                                        onChange={() => handleRowSelect(sr?.clientCode)}
                                                                        disabled={sr.deliveryStatus !== "bounced" && sr.deliveryStatus !== "unsubscribed" && sr.deliveryStatus !== "abuse"}
                                                                    />
                                                                </td>
                                                                <td className="cl-code" onClick={() => handleClDetailsModal(sr?.id)}>{sr?.clientCode || "-"}</td>
                                                                <td>{sr?.clientName ? toTitleCase(sr?.clientName) : "-"}</td>
                                                                <td>{sr.dematAcNo || "-"}</td>
                                                                <td>{sr.email || "-"}</td>
                                                                <td>{formattedDateSlash(sr.accOpenDate) || "-"}</td>
                                                                <td>{formattedDateSlash(sr.t2Deadline) || "-"}</td>
                                                                <td>{formattedDateSlash(sr.commDate) || "-"}</td>
                                                                <td>{sr.deliveryStatus !== "" ?
                                                                    <span className={getStatusClass(sr?.deliveryStatus)}>
                                                                        {toSentenceCase(sr?.deliveryStatus)}
                                                                    </span>
                                                                    : ""} </td>
                                                                <td>{sr.remarks || "-"}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </>
                                            :
                                            <div className="step-content report-error-message">
                                                {noDataFound()}
                                            </div>
                                    }
                                </div>
                            </div>

                            {serviceRequests && serviceRequests?.length > 0 && (
                                <div className="d-flex align-items-center justify-content-between">

                                    <div className="pagination-left d-flex align-items-center">
                                        <span className="items-label">Items per page</span>

                                        <select
                                            value={limit}
                                            onChange={(e) => {
                                                setLimit(Number(e.target.value));
                                                setPage(1);
                                            }}
                                            className="page-select"

                                        >
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>

                                        <span className="page-count">
                                            {count === 0
                                                ? "0-0 items"
                                                : `${(page - 1) * limit + 1}-${Math.min(
                                                    page * limit,
                                                    count
                                                )} of ${count} items`}
                                        </span>
                                    </div>

                                    <div className="pagination-right d-flex align-items-center">

                                        <button
                                            className="pagination-btn"
                                            disabled={page === 1}
                                             onClick={() => {
                                                setPage(startPage - pagesPerGroup);
                                            }}
                                        >
                                            &lt;
                                        </button>
                                        {visiblePages.map((pageNumber) => (
                <button
                    key={pageNumber}
                    className={`pagination-number ${
                        page === pageNumber ? "active-page" : ""
                    }`}
                    onClick={() => setPage(pageNumber)}
                >
                    {pageNumber}
                </button>
            ))}

             <button
                className="pagination-btn"
                disabled={endPage === totalPages}
                onClick={() => {
                    setPage(endPage + 1);
                }}
            >
                &gt;
            </button>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </main>
            </div>

            <Modal
                show={filterModal}
                onHide={() => setFilterModal(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="inactive-modal setting-model welcome-letter-modal"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header className="modal-header">
                    <Modal.Title id="contained-modal-title-vcenter modal-title">
                        <div className="figure-inlac header-pnl">
                            <span className="header-title">Select Custom Date</span>
                        </div>
                    </Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={handleCloseFilter}
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive model-top-active-table rm-dashboard-filter"
                        onKeyDown={handleFilterKeyDown}>

                        <DateRangePicker
                        dateErr={dateErr}
                            key={resetKey}
                            fromDate={fromDate}
                            toDate={toDate}
                            onFromDateChange={(date) => {
                                setFromDate(date);
                                setDateErr("")
                            }}
                            onToDateChange={(date) => {
                                setToDate(date);
                                setDateErr("")
                            }}
                            // onReset={() => {
                            //     setFromDate("");
                            //     setToDate("");
                            // }}
                            // onApply={({ fromDate, toDate }) => {
                            //     setFromDate(fromDate);
                            //     setToDate(toDate);

                            //     handleApplyFilter(fromDate, toDate);
                            // }}
                        />
                        <div className="modal-footer">
                            <button type="button" className="back-btn" onClick={() => handleResetFilter()}
                            >RESET</button>
                            <button type="submit" className="submit-btns" onClick={handleApplyFilter}
                            >
                                APPLY
                            </button>
                        </div>

                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={rejectionModal}
                onHide={() => setRejectionModal(false)}
                centered
                size="lg"
                backdrop="static"
                keyboard={false}
                className="request-history-modal"
            >
                <Modal.Header closeButton>
                    <div className="request-header">
                        <div className="avatar">
                            <span className="initials">{getInitials(clDetails?.clientName)}</span>
                        </div>

                        <div className="client-details">
                            <div className="title-row">
                                <span className="cl-title">{clDetailsLoader ?
                                    <SmallLoader />
                                    :
                                    <> {toTitleCase(clDetails?.clientName) || "-"} ({clDetails?.clientCode || "-"})</>
                                }</span>

                                {clDetails?.deliveryStatus !== "" ?
                                    <span className={getStatusClass(clDetails?.deliveryStatus)}>
                                        {toSentenceCase(clDetails?.deliveryStatus)}
                                    </span>
                                    : "-"
                                }
                            </div>

                            <p>Email- {clDetailsLoader ?
                                <SmallLoader />
                                :
                                <>{clDetails?.email || "-"}</>
                            }</p>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setRejectionModal(false)}
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>

                <Modal.Body>

                    <h6 className="section-title">
                        Request History
                    </h6>

                    <div className="history-wrap">
                        <div className="history-grid">

                            <div className="history-item">
                                <label>Account opening date</label>
                                <span>{clDetailsLoader ?
                                    <SmallLoader />
                                    :
                                    <>{formattedDateSlash(clDetails?.accountOpeningDate) || "-"}</>
                                }</span>
                            </div>

                            <div className="history-item">
                                <label>T+2 deadline</label>
                                <span>{clDetailsLoader ?
                                    <SmallLoader />
                                    :
                                    <>{formattedDateSlash(clDetails?.t2Deadline) || "-"}</>
                                }</span>
                            </div>

                            <div className="history-item">
                                <label>Demat A/C No.</label>
                                <span>{clDetailsLoader ?
                                    <SmallLoader />
                                    :
                                    <>{clDetails?.dematAccountNo || "-"}</>
                                }</span>
                            </div>

                        </div>
                        <div className="history-grid">

                            <div className="history-item">
                                <label>Matched comm. date</label>
                                <span>{clDetailsLoader ?
                                    <SmallLoader />
                                    :
                                    <>{formattedDateSlash(clDetails?.matchedCommDate) || "-"}</>
                                }</span>
                            </div>

                            <div className="history-item">
                                <label>Delivery status</label>
                                <span>{clDetailsLoader ?
                                    <SmallLoader />
                                    :
                                    <>{clDetails?.deliveryStatus || "-"}</>
                                }</span>
                            </div>

                            <div className="history-item">
                                <label>Matched subject line</label>
                                <span>{clDetailsLoader ?
                                    <SmallLoader />
                                    :
                                    <>{clDetails?.matchedSubjectLine || "-"}</>
                                }</span>
                            </div>

                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
}

export default WelcomeLetterDashboard;
